<template>
    <div id="newinquiry">
        <nav>
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="openNav()" src="/assets/burger.png" alt="burger" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
            <div class="sideNav" :style="{ width: navWidth + 'px' }">
                <div class="leftNav">
                    <div class="innerNav">
                        <img class="navLogout" v-on:click="openNav()" src="/assets/burgerwhite.png" alt="burger" />
                    </div>
                </div>
                <div v-if="navMenuVisible" class="navsidecontent">
                    <div class="navtitle noborder">
                        Gérer les biens et demandes
                    </div>
                    <div v-on:click="goToNewBuildingPage" class="navsubtitle">
                        Créer un nouveau bien
                    </div>
                    <div v-on:click="goToBuildingPage" class="navsubtitle">
                        Consulter/Modifier les biens et demandes
                    </div>
                    <div class="navtitle">
                        Plannings
                    </div>
                    <div v-on:click="goToPlanningPage" class="navsubtitle">
                        Consulter/Modifier les plannings
                    </div>
                    <div v-on:click="goToTimeSheetPage" class="navsubtitle">
                        Fiches horaires
                    </div>
                    <div class="navtitle">
                        Groupes
                    </div>
                    <div v-on:click="goToNewGroupPage" class="navsubtitle">
                        Ajouter un groupe
                    </div>
                    <div v-on:click="goToAllGroupPage" class="navsubtitle">
                        Voir/Modifier les groupes
                    </div>
                    <div class="navtitle">
                        Utilisateurs
                    </div>
                    <div v-on:click="goToNewUserPage" class="navsubtitle">
                        Ajouter un utilisateur
                    </div>
                    <div v-on:click="goToAllUserPage" class="navsubtitle">
                        Voir/Modifier les utilisateurs
                    </div>
                    <div v-on:click="logout()" class="navtitle logout">
                        Déconnexion
                    </div>
                </div>
            </div>
        </nav>
        <div class="filAriane">
            <span v-html="filAriane"></span>
        </div>
        <div class="outercircle">
            <div class="homeName">
                {{Name}}
            </div>
            <div id="circle"></div>
        </div>
        <h1>
            <button v-on:click="backbtn()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
            Nouveau demande - <span v-html="getFullAddress(building.buildingAddress)"></span>
        </h1>
        <div class="container">
            <div class="textline">
                <b class="textLen">Name :</b>
                <span style="text-align: center;" class="fifty">{{inquiry.name}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;</span>
                <input class="inputTxt fifty" type="text" v-model="complement" >
            </div>
            <div class="textline">
                <b class="textLen">Type <i style="color:red;">*</i>&nbsp;&nbsp;:</b>
                <select class="inputTxt select" v-model="inquiry.type">
                    <option class="inputTxt" :value="''" selected>
                        Sélectionner
                    </option>
                    <option class="inputTxt" :value="'Demande Standard'">
                        Demande Standard
                    </option>
                    <option class="inputTxt" :value="'Entretien chaudière fioul'">
                        Entretien chaudière fioul
                    </option>
                    <option class="inputTxt" :value="'Entretien chaudière gaz'">
                        Entretien chaudière gaz
                    </option>
                    <option class="inputTxt" :value="'Climatisation'">
                        Climatisation
                    </option>
                </select>
            </div>
            <div class="textline">
                <b class="textLen">Utilisateur <i style="color:red;">*</i>&nbsp;&nbsp;:</b>
                <select class="inputTxt select" v-model="inquiry.userInCharge">
                    <option class="inputTxt" :value="{}" selected>
                        Sélectionner
                    </option>
                    <option class="inputTxt" v-for="(itemIncharge, indexIncharge) in inchargeToSelect" :key="indexIncharge" :value="{idWeweb:itemIncharge.idWeweb}">
                        {{itemIncharge.address.firstName +" "+itemIncharge.address.lastName}}
                    </option>
                </select>
            </div>
            <div class="textline">
                <b class="textLen high">Bloc notes :</b>
                <textarea rows="8" class="inputTxt area" type="text"  v-model="inquiry.note" ></textarea>
            </div>
        </div>
        <div class="btnContainer">
            <button v-on:click="uploadInquiry()" class="btn">Valider</button>
        </div>
        
        <modal height="250px" width="400px" name="validationModal">
            <div class="modalDiv">  
                <div class="txtDiv">
                    <img class="modalTxt" :src="imgValidation"/>
                </div>  
                <div class="txtDiv">
                    <span class="modalTxt">{{validationPhrase}}</span>
                </div>    
                <button class="docBtn3" type="button" v-on:click="okButton()">OK</button>   
            </div>    
        </modal>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'Newinquiry',
        data() {
            return {
                Name:"ADPR",
                navWidth:0,
                navMenuVisible:false,
                filAriane: "",
                complement: "",
                validationPhrase: "La nouvelle demande a été correctement enregistré",
                imgValidation: "/assets/right.png",
                allInquiryNames: [],
                inchargeToSelect:   [],
                building: {},
                inquiry: {
                    status :        "en attente de rendez-vous",
                    timestamp :     0,
                    type :          '',
                    note :          "",
                    name :          "",
                    userInCharge:   {}
                },
            };
        },
        methods:{
            openModal(){
                this.$modal.show('validationModal');
            },
            closeModal(){
                this.$modal.hide('validationModal');
            },
            okButton(){
                if(this.validationPhrase === "La nouvelle demande a été correctement enregistré"){
                    this.goToInquiryPage(this.inquiry.name);
                }
                else{
                    this.$modal.hide('validationModal');
                }
            },
            backbtn(){

                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);
                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);
                
                this.$cookie.set('history', JSON.stringify(arrHist.slice(0, -1)));
                this.$cookie.set('historyQuery', JSON.stringify(arrQuery.slice(0, -1)));

                if(arrHist.length){
                    if(arrQuery[arrQuery.length-1] !== "" && arrQuery[arrQuery.length-1] !== "undefined"){
                        this.$router.replace({ name: arrHist[arrHist.length-1], query: {name: arrQuery[arrQuery.length-1]} });
                    }
                    else{
                        this.$router.replace({ name: arrHist[arrHist.length-1] });
                    }
                }
                else{
                    this.$cookie.set('currentAriane', "");
                    this.$router.replace({ name: "adminhome" });
                }
            },
            getFullAddress(a){
                if(a){
                    return "&nbsp;&nbsp;" + a.streetNb + "&nbsp;&nbsp;" + a.streetName + "&nbsp;&nbsp;" + a.postalCode + "&nbsp;&nbsp;" + a.city;
                }
                else{
                    return '';
                }
            },
            async getAllInquiriesNames(){
                                
                var response = await axios.get('https://so.gaviota.fr/api/building/admin/inquiry/name');
                
                if(response){
                    this.allInquiryNames = response.data.inquiries;
                    this.generateNewName();
                }
            },
            generateNewName(){

                var InquiryName = this.building.name + "_";

                var n = new Date();
                var y = n.getFullYear();
                var day = "0" + n.getDate();
                var month = "0" + (n.getMonth() + 1);
                InquiryName +=day.substr(-2) + '' + month.substr(-2) + '' +y;

                var isInquiryNameUnique = false;
                while(!isInquiryNameUnique){
                    isInquiryNameUnique = true;
                    for(var i = 0; i<this.allInquiryNames.length; i++){
                        if(InquiryName === this.allInquiryNames[i].name){
                            isInquiryNameUnique = false;
                            if(this.allInquiryNames[i].name.slice(-2).substr(0,1) !== "_"){
                                InquiryName = InquiryName+"_b";
                            }
                            else if(this.allInquiryNames[i].name.slice(-2) === "_b"){
                                InquiryName = InquiryName.substr(0, InquiryName.length-2)+"_t";
                            }
                            else if(this.allInquiryNames[i].name.slice(-2).slice(-2) === "_t"){
                                InquiryName = InquiryName.substr(0, InquiryName.length-2)+"_q";
                            }
                            else if(this.allInquiryNames[i].name.slice(-2).slice(-2) === "_q"){
                                InquiryName = InquiryName.substr(0, InquiryName.length-2)+"_p";
                            }
                            else if(this.allInquiryNames[i].name.slice(-2).slice(-2) === "_p"){
                                InquiryName = InquiryName.substr(0, InquiryName.length-2)+"_h";
                            }
                            else if(this.allInquiryNames[i].name.slice(-2).slice(-2) === "_h"){
                                InquiryName = InquiryName.substr(0, InquiryName.length-2)+"_s";
                            }
                            else if(this.allInquiryNames[i].name.slice(-2).slice(-2) === "_s"){
                                InquiryName = InquiryName.substr(0, InquiryName.length-2)+"_o";
                            }
                            else if(this.allInquiryNames[i].name.slice(-2).slice(-2) === "_o"){
                                InquiryName = InquiryName.substr(0, InquiryName.length-2)+"_n";
                            }
                            else if(this.allInquiryNames[i].name.slice(-2).slice(-2) === "_n"){
                                InquiryName = InquiryName.substr(0, InquiryName.length-2)+"_d";
                            }
                            else if(this.allInquiryNames[i].name.slice(-2).slice(-2) === "_d"){
                                InquiryName = InquiryName.substr(0, InquiryName.length-2)+"_u";
                            }
                            else{
                                InquiryName = InquiryName.substr(0, InquiryName.length-2)+ Math.round(new Date().getTime()/1000);
                            }
                        }
                    }
                }    
                
                this.inquiry.name = InquiryName.toLowerCase();

            },
            async uploadInquiry(){

                this.inquiry.name += "-"+this.complement.toLowerCase().replace(/ /g, '_');

                this.inquiry.timestamp = new Date() / 1000 | 0;

                if(this.inquiry.type !== "" && this.inquiry.userInCharge !== {}){

                    var response = await axios.post('https://so.gaviota.fr/api/building/inquiry/'+this.building._id, {inquiry: this.inquiry});

                    if(response){
                        this.validationPhrase =  "La nouvelle demande a été correctement enregistré",
                        this.imgValidation = "/assets/right.png",
                        this.openModal();                        
                    }
                    else{
                        this.validationPhrase =  "Une erreur s'est produite, veuillez réessayer",
                        this.imgValidation = "/assets/wrong.png",
                        this.openModal();
                    }
                }
                else{
                    this.validationPhrase =  "Veuillez remplir les champs obligatoires * ",
                    this.imgValidation = "/assets/wrong.png",
                    this.openModal();
                }
            },
            goToInquiryPage(name){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);
                
                this.$router.replace({ name: "inquiryadmin", query: {name: name}  });
            },
            goToBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "buildinglist"});
            },
            goToNewBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newbuilding"});
            },
            goToPlanningPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "planningadmin"});
            },
            goToTimeSheetPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "timesheet"});
            },
            goToAllUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "alluser"});
            },
            goToNewUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newuser"});
            },
            goToAllGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "allgroup"});
            },
            goToNewGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newgroup"});
            },
            refresh(){
                location.reload();
            },
            openNav(){
                 
                if(!this.navWidth){
                    this.navWidth = 300;
                }
                else{
                    this.navWidth = 0;
                }
                
                var vm = this;
                setTimeout(function(){
                    vm.navMenuVisible = !vm.navMenuVisible;
                }, 100);
            },
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('historyQuery');
                this.$cookie.delete('history');
                this.$router.replace({ name: "login" });
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$cookie.set('history', "");
                this.$cookie.set('historyQuery', "");
                this.$router.replace({ name: "adminhome" });
            },
            getCookies: function() {
                this.$cookie.set('currentAriane', "Bien n° " +this.$route.query.name);
                this.filAriane = this.$cookie.get('currentAriane');
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || (this.$cookie.get('role') !== "admin" && this.$cookie.get('role') !== "technicien bureau") || !this.$route.query.name){
                    this.$router.replace({ name: "login" });
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    this.getBuilding();
                }
            },
            async getBuilding(){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/building/'+this.$route.query.name);
                
                if(response.data.building){
                    this.building = response.data.building;
                    this.getUserData();
                }
                else{
                    this.logout();
                }
            },
            async getUserData(){
                var response = await axios.get('https://so.gaviota.fr/api/userdata/admin/all');
                if(response.data.users){
                    for(var i=0; i<response.data.users.length; i++){
                        if(response.data.users[i].role === "admin" || response.data.users[i].role.indexOf("tech") > -1 ){
                            this.inchargeToSelect.push(response.data.users[i]);
                        }
                    } 
                    this.getAllInquiriesNames();                 
                }
            },
        },
        mounted(){
            this.getCookies();
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #newinquiry {
        width: 90%;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 60px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
        position:relative;
    }
    @media screen and (max-width: 768px) {
        .h1 {
              font-size: 24px;
            }
    }
    h2{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding:15px;
        font-size: 24px;
        font-weight: 600;
        display: block;
        border-bottom: 2px solid #1ce83e6e;
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }

    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }

    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    #circle {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #1ce83e;
        margin:auto;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
    
    .btn{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        display: inline-block;
        width: 100px;
    }
    .left{
        float:left;
    }
    .right{
        float:right;
    }
    .imgCard{
        width:100%;
        height: 200px;
        object-fit: cover;
        cursor: pointer;
    }
    .btnCard{
        width:20px;
        height: 20px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 20px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    #circleRed {
        width: 10px;
        height: 10px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        background: #ff0000;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 60px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .divCard{
        vertical-align: middle;
        position: relative;
        background-color: #F0F0F0;
        border-bottom: 2px solid;
        border-color:#1ce83e28;
        padding:10px;
        margin:2px;
    }
    .spanCard{
        display:inline-block;
        padding-left:5px;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 17px;
    }
    @media screen and (max-width: 768px) {
        .spanCard {
              font-size: 14px;
            }
    }
   .btnAccordion{
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
        border:none;
        cursor: pointer;
        width: calc(100% - (5px + 5px));
        display: inline-block;
        text-align: left;
        background-color: #FFF;
        margin: 5px;
    }
    .btnAccordionNone{
        cursor: default;
        padding-left:15px;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        text-align: left;
        background-color: #1ce83e;
        font-size: 30px;
        position: absolute;
        left: 1%;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .notifList{
        margin-bottom: 10px;
    }
    .container{
        padding: 20px;
        font-size: 17px;
        font-family: 'BenchNine', sans-serif;
    }
    .btnContainer{
        padding:20px;
        background-color: #FFF;
        margin-bottom: 20px;
        text-align: center;
    }
    hr{
        margin-bottom: 0px;
        border-color: rgba(240, 240, 240, 0.3);
        color: rgba(240, 240, 240, 0.3);
    }
    .filAriane{
        background-color: #F0F0F0;
        font-family: 'BenchNine', sans-serif;
        padding-top:20px;
        margin-left:-50px;
        margin-bottom:-17px;
        font-size: 17px;
    }		
    .sideNav{
        background-clip: border-box;
        background-color: #FFF;
        background-origin: padding-box;
        box-sizing: border-box;
        background-color: #333;
        display: block;
        height: 100%;
        overflow:auto;
        box-shadow: 8px 0px 6px -6px #999;
        position:fixed;
        top:0;
        left:0;
        z-index:10;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navsidecontent{
        color:white;
        font-family: 'BenchNine', sans-serif;
        margin-top:65px;
        margin-left:30px;
        margin-right:30px;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navtitle{
        margin:10px;
        margin-top:15px;
        padding-top:5px;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        border-top: 1px solid;
        border-color:#eee;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:default;
                              
    }
    .navsubtitle{
        margin:7px;
        font-size: 18px;
        font-weight: 400;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:pointer;
    }
    .navsubtitle:hover{
        color:#999;
    }
    .noborder{
        border:none;
        margin-top:5px;
        padding-top:0px;
    }
    .logout{
        padding-top:50px;
        cursor:pointer;
    }
    .textline{
        padding:5px;
    }
    
	/* width */
	::-webkit-scrollbar {
		width: 6px;
	}
	
	/* Track */
	::-webkit-scrollbar-track {
		background: #ddd; 
	}
	
	/* Handle */
	::-webkit-scrollbar-thumb {
		background: #888; 
		border-radius: 3px;
	}
	
	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #555; 
	}
    .editBtn{
        width:30px;
        height: 30px;
        position:absolute;
        bottom:20px;
        right:20px;
        cursor:pointer;
    }
    .inputTxt{
        width:calc(100% - (100px + 50px));
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
        background-color: #F7F7F7;
        border: 1px solid #bbb;
        padding-left:5px;
        margin-left:5px;
        display: inline-block;
    }
    .fifty{
        width:calc(50% - (25px + 50px));
        display: inline-block;
    }
    .inlineBlock{
        display: inline-block;
    }
    .btnNewBtn{
        width:25px;
        height: 25px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:black;
        cursor: pointer;
        background-color: #1ce83e;
        display:inline-block;
        margin:10px;
    }
    .area{
        resize: none;
        width: calc(100% - (100px + 50px));
    }
    .select{
        width: calc(100% - (100px + 40px));
        margin-bottom:10px;
    }
    h3{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        margin: 0px 0px 0px 15px;
    }
    .textLen{
        width:120px;
        display: inline-block;
    }
    .radioBtn{
        margin-left:10px;
        margin-right:5px;
    }
    input[type='radio']:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background-color: #d1d3d1;
        content: '';
        display: inline-block;
        visibility: visible;
        border: 1px solid grey;
    }
    input[type='radio']:checked:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -2px;
        left: -1px;
        position: relative;
        background: radial-gradient(#1ce83e, #ddd);
        content: '';
        display: inline-block;
        visibility: visible;
        border: 1px solid grey;
    }
    .blockBtn{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: block;
    }
    .modalDiv{
        margin:30px;
        text-align: center;
    }
    .modalTxt{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
    }
    .txtDiv{
        margin-bottom: 15px; 
    }
    .docBtn3{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: inline-block;
        border:none;
        color:#1ce83e;
        font-size: 18px;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        width: 200px;
    }
    .high{
        height: 200px;
        vertical-align:top;
    }
</style>